import { ref, computed, reactive } from 'vue'
import { defineStore } from 'pinia'
import { COMPANY_TYPE, type Company } from './types'
import { faker } from '@faker-js/faker'
import axios from 'axios'
import { API } from '@/config'

const apiURL: string = API

const api = axios.create({
  baseURL: apiURL + '/v1'
})

export const useCompanyStore = defineStore('company', () => {
  const companies = reactive(Array<Company>())
  const selectedCompany = ref({} as Company) // selected in table
  const thisCompany = ref({} as Company) //for form editing

  const showForm = ref(false)


  async function generateCompanies(count = 100) {
  
    for (let i = 0; i < count; i++) {
      const payload = {} as Company

      payload.type_ = COMPANY_TYPE.Customer
      payload.name = faker.company.name()
      payload.code = faker.string.uuid().split('-')[0]
      payload.address = faker.location.streetAddress()
      payload.city = faker.location.city()
      payload.contact_person = faker.person.fullName()
      payload.phone = faker.phone.number()
      payload.email = faker.internet.email()
      payload.zip_code = faker.location.zipCode()

      await saveCompany(payload)
    }

  }


  async function saveCompany(payload: Company) {
    if (payload.uuid) {
      const response = (await api.put('/companies/' + payload.uuid, payload))

      if (response.status == 200) {
        companies.push(response.data)
      } else {
      }
    } else {
      const response = (await api.post('/companies.json', payload))

      if (response.status == 200) {
        companies.push(response.data)
      } else {
      }
    }
  }


  async function addCompany(payload: Company) {
    const response = (await api.post('/companies.json', payload))

    if (response.status == 200) {
      companies.push(response.data)
    } else {
    }


  }

  async function deleteCompany(payload: Company) {
    const response = (await api.delete('/companies/' + payload.uuid))

    if (response.status == 200) {
      const idx = companies.findIndex((item: Company)=>item.uuid == payload.uuid)
      companies.splice(idx,1)
    } else {
    }


  }

  const importCompanies = async (companies: any) => {
    for (let index = 0; index < companies.length; index++) {
      if (companies[index]['uuid'] == 'uuid') {
        continue
      }
      // const {uuid,...company} = companies[index]
      const {uuid,...company} = companies[index]


      const payload = {} as Company

      Object.assign(payload,{...company})
      await saveCompany(payload)
    }
  }


  const companyName = computed(()=>(uuid: string)=>{
    return companies.find((item: Company)=>item.uuid == uuid)?.name

  })

  const companyCode = computed(()=>(uuid: string)=>{
    return companies.find((item: Company)=>item.uuid == uuid)?.code

  })

  const companyUuid = computed(()=>(name: string)=>{
    return companies.find((item: Company)=>item.name.toLocaleLowerCase() == name.toLocaleLowerCase())?.uuid

  })

  async function getCompanies() {

    const response = (await api.get('/companies.json'))
    if (response.status == 200) {
      // companies.length=0
      // response.data.data.forEach((item: Company)=>{
      //   companies.push(item)
      // })
      Object.assign(companies,[])
      Object.assign(companies,response.data.data)
    } else {
    }
  }



  return {
    showForm,
    companies,
    selectedCompany,
    thisCompany,
    // generateCompanies,
    getCompanies,
    saveCompany,
    addCompany,
    deleteCompany,
    importCompanies,

    companyName,
    companyUuid,
    companyCode,
  }
})
